/* Panier HOVER de qalbeen.store : tiroir <cart-drawer> + page /cart.
   - Ouvre le tiroir après tout ajout au panier (formulaires Dawn, ajouts rapides, lots et suggestions des fiches…).
   - Offres (réglages : snippets/hover-cart-config.liquid → window.HPN.qb ; source : snippets/qb-offre-cfg.liquid) :
       Malaisie (qb.m = 'my') : le panier tient lui-même les cadeaux à jour, lignes marquées par la propriété _qb_gift :
         pouch   : quantité de pochons offerts = nombre de produits achetés (éditions de cartes + Yusra Hijab payants, hors cadeaux) ;
         yusra   : 1 Yusra Hijab offert dès 2 produits (couleur choisie par la cliente dans le panier, [data-qb-pick="yusra"]) ;
         edition : 1 édition de cartes offerte dès 3 produits (choisie dans le panier, [data-qb-pick="edition"]).
         Sous le seuil, le cadeau est retiré. Un hijab acheté et un hijab offert sont deux lignes différentes (propriétés différentes).
       Reste du monde : rien n'est ajouté ni retiré (la progression du lot est affichée par Liquid, snippets/qb-cart-offre.liquid).
     Les cadeaux sont rendus gratuits par les réductions automatiques Shopify : aucun code n'est posé par le thème.
   - Jamais de modification d'une ligne qui n'est pas un cadeau ; rien n'est fait sur un panier vide.
   - Une seule opération sur le panier à la fois (file), au plus 3 passes de mise en ordre, ajout refusé (stock) = on n'insiste
     pas pour ce nombre de produits (sessionStorage) : aucune boucle possible.
   - Après chaque mise à jour : événement document « qb:cart » {n: produits achetés (Malaisie), w: articles du lot (monde)}
     (lu par l'échelle des cadeaux des fiches, assets/hover-qb-offre.js). */
(function () {
  'use strict';
  var C = window.HPN; if (!C || window.__hpnLoaded) return; window.__hpnLoaded = true;
  var D = document, W = window;
  var R = ((W.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var origFetch = W.fetch.bind(W);
  var drawer = D.querySelector('[data-hpn-drawer]');
  var page = D.querySelector('[data-hpn-page]');
  var Q = C.qb || {};
  var MY = Q.m === 'my';
  var flashMsg = '', lastFocus = null, modifie = false;

  /* ---------- outils ---------- */
  function api(path, body) {
    return origFetch(R + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-HPN': '1' }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'cart'); e.data = j; throw e; } return j; }); });
  }
  function getCart() { return api('cart.js'); }
  function props(it) { return it.properties || {}; }
  function giftType(it) { return props(it)._qb_gift || ''; }
  /* produit qui compte pour les cadeaux de Malaisie : édition de cartes ou Yusra Hijab, acheté (pas un cadeau) */
  function compteMY(it) { return !giftType(it) && ((Q.eds || []).indexOf(it.handle) >= 0 || it.handle === Q.hijab); }
  function nMY(cart) { return cart.items.reduce(function (s, it) { return compteMY(it) ? s + it.quantity : s; }, 0); }
  function nMonde(cart) { return cart.items.reduce(function (s, it) { return !giftType(it) && (Q.monde || []).indexOf(it.handle) >= 0 ? s + it.quantity : s; }, 0); }
  /* le cadeau est-il bien le bon produit ? (une ligne _qb_gift sur un autre produit est retirée) */
  function giftOk(it, t) {
    if (t === 'pouch') return it.handle === Q.pouch;
    if (t === 'yusra') return it.handle === Q.hijab;
    if (t === 'edition') return (Q.eds || []).indexOf(it.handle) >= 0;
    return false;
  }

  /* ajouts refusés par Shopify (stock) pour un nombre de produits donné : on n'insiste pas */
  var bloques = {};
  try { bloques = JSON.parse(sessionStorage.getItem('qb-bloques') || '{}') || {}; } catch (e) {}
  function bloque(k, n) { return bloques[k] === n; }
  function bloquer(k, n) { bloques[k] = n; try { sessionStorage.setItem('qb-bloques', JSON.stringify(bloques)); } catch (e) {} }

  /* ---------- file d'opérations ---------- */
  var chain = Promise.resolve(), busy = 0;
  function q(fn) {
    busy++; setBusy(true);
    chain = chain.then(fn).catch(function (e) { if (W.console) console.warn('[panier HOVER]', e); flash(C.t.error); return rendre().catch(function () {}); })
      .then(function () { busy--; if (!busy) setBusy(false); });
    return chain;
  }
  function setBusy(b) { [drawer, page].forEach(function (el) { if (el) el.classList.toggle('is-busy', b); }); }

  /* ---------- cadeaux de Malaisie ---------- */
  /* plan = ce qu'il faut changer pour que les cadeaux correspondent au panier : { rm: {clé: 0 ou quantité plus basse}, up: [{key, quantity}], add: [...] } */
  function plan(cart) {
    var out = { rm: {}, up: [], add: [] };
    var gifts = cart.items.filter(giftType);
    if (!cart.items.length || !gifts.length && !MY) { out.vide = true; return out; }
    if (!MY) { gifts.forEach(function (it) { out.rm[it.key] = 0; }); out.vide = !gifts.length; return out; }
    var n = nMY(cart), vus = {};
    gifts.forEach(function (it) {
      var t = giftType(it);
      if (!giftOk(it, t) || vus[t]) { out.rm[it.key] = 0; return; } /* mauvais produit ou doublon */
      vus[t] = it;
    });
    /* pochons : autant que de produits achetés */
    var p = vus.pouch;
    if (!n || !Q.pouchId) { if (p) out.rm[p.key] = 0; }
    else if (!p) { if (!bloque('pouch', n)) out.add.push({ id: Q.pouchId, quantity: n, properties: { _qb_gift: 'pouch' } }); }
    else if (p.quantity > n) out.rm[p.key] = n;
    else if (p.quantity < n && !bloque('pouch', n)) out.up.push({ key: p.key, quantity: n, k: 'pouch' });
    /* hijab offert dès 2, édition offerte dès 3 : une seule unité, retirés sous le seuil (jamais ajoutés d'office : la cliente choisit) */
    [['yusra', 2], ['edition', 3]].forEach(function (r) {
      var it = vus[r[0]]; if (!it) return;
      if (n < r[1]) out.rm[it.key] = 0; else if (it.quantity > 1) out.rm[it.key] = 1;
    });
    out.vide = !Object.keys(out.rm).length && !out.up.length && !out.add.length;
    out.n = n;
    return out;
  }
  function appliquer(p) {
    modifie = true;
    var s = Promise.resolve();
    /* 1. retraits et baisses (ne peuvent pas échouer pour une question de stock) en une seule écriture */
    if (Object.keys(p.rm).length) s = s.then(function () { return api('cart/update.js', { updates: p.rm }); });
    /* 2. hausses de quantité du pochon */
    /*    (stock insuffisant : Shopify refuse ou plafonne → on n'insiste plus pour ce nombre de produits) */
    p.up.forEach(function (u) {
      s = s.then(function () {
        return api('cart/change.js', { id: u.key, quantity: u.quantity }).then(function (c) {
          var it = (c.items || []).filter(function (x) { return x.key === u.key; })[0];
          if (!it || it.quantity < u.quantity) bloquer(u.k, p.n);
        }, function () { bloquer(u.k, p.n); });
      });
    });
    /* 3. ajout des pochons manquants */
    if (p.add.length) s = s.then(function () {
      return api('cart/add.js', { items: p.add }).then(function (r) {
        var got = (r.items || []).reduce(function (t, x) { return t + (x.quantity || 0); }, 0);
        if (got < p.add[0].quantity) bloquer('pouch', p.n);
      }, function () { bloquer('pouch', p.n); });
    });
    return s;
  }
  var dernier = null;
  function synchro() {
    return getCart().then(function (cart) {
      if (!C.enabled) return (dernier = cart);
      var pass = 0;
      function boucle(c) {
        var p = plan(c);
        if (p.vide || pass++ >= 3) return (dernier = c);
        return appliquer(p).then(getCart).then(boucle);
      }
      return boucle(cart);
    });
  }
  /* choix du hijab ou de l'édition offerts : remplace le cadeau du même type */
  function choisirCadeau(t, id) {
    return q(function () {
      return getCart().then(function (c) {
        var n = nMY(c), seuil = t === 'yusra' ? 2 : 3;
        if (n < seuil) return;
        var u = {}, deja = false;
        c.items.forEach(function (it) { if (giftType(it) === t) { if (it.variant_id === id && !deja) deja = true; else u[it.key] = 0; } });
        var s = Object.keys(u).length ? api('cart/update.js', { updates: u }) : Promise.resolve();
        if (deja) return s;
        return s.then(function () { return api('cart/add.js', { items: [{ id: id, quantity: 1, properties: { _qb_gift: t } }] }); })
          .then(function () { flash(''); }, function () { flash(C.t.giftKo); });
      }).then(synchro).then(rendre);
    });
  }

  /* ---------- rendu ---------- */
  function rendre() {
    var ids = [];
    if (drawer) ids.push('hover-cart-drawer');
    if (page) ids.push(page.getAttribute('data-section'));
    ids.push('cart-icon-bubble');
    return origFetch(R + 'cart?sections=' + ids.join(','), { credentials: 'same-origin', headers: { 'X-HPN': '1' } }).then(function (r) { return r.json(); }).then(function (j) {
      var parse = function (h) { return new DOMParser().parseFromString(h || '', 'text/html'); };
      if (drawer && j['hover-cart-drawer']) remplacer(drawer.querySelector('#HvCartBody'), parse(j['hover-cart-drawer']).querySelector('[data-hpn-body]'));
      if (page && j[page.getAttribute('data-section')]) remplacer(page, parse(j[page.getAttribute('data-section')]).querySelector('[data-hpn-page] [data-hpn-body]'));
      var ic = D.getElementById('cart-icon-bubble');
      if (ic && j['cart-icon-bubble']) { var s = parse(j['cart-icon-bubble']).querySelector('.shopify-section'); if (s) ic.innerHTML = s.innerHTML; }
      peindre();
      annoncer();
    });
  }
  function annoncer() {
    if (!dernier) return;
    try { D.dispatchEvent(new CustomEvent('qb:cart', { detail: { n: nMY(dernier), w: nMonde(dernier), m: Q.m } })); } catch (e) {}
  }
  function remplacer(box, neuf) {
    if (!box || !neuf) return;
    /* les boutons de paiement express sont rangés hors du contenu remplacé, puis remis sous le bouton par peindre() */
    var ex = box.querySelector('[data-hpn-express]');
    if (ex) { ex.hidden = true; (box.closest('[data-hpn-drawer]') || box.closest('.hpn-pagewrap') || D.body).appendChild(ex); }
    var sc = box.querySelector('[data-hpn-scroll]'), y = sc ? sc.scrollTop : 0;
    var det = Array.prototype.map.call(box.querySelectorAll('details'), function (d) { return d.open; });
    box.innerHTML = ''; box.appendChild(neuf);
    var sc2 = box.querySelector('[data-hpn-scroll]'); if (sc2) sc2.scrollTop = y;
    Array.prototype.forEach.call(box.querySelectorAll('details'), function (d, i) { if (det[i]) d.open = true; });
  }
  function peindre() {
    var vide = true;
    D.querySelectorAll('[data-hpn-body]').forEach(function (body) {
      if ((+body.getAttribute('data-count') || 0) > 0) vide = false;
      /* paiement express : déplacé sous le bouton */
      var slot = body.querySelector('[data-hpn-express-slot]'), root = body.closest('[data-hpn-drawer]') || body.closest('.hpn-pagewrap');
      var ex = root && root.querySelector('[data-hpn-express]');
      if (slot && ex) { slot.appendChild(ex); ex.hidden = false; }
      var f = body.querySelector('[data-hpn-flash]'); if (f) { f.hidden = !flashMsg; f.textContent = flashMsg; }
    });
    if (drawer) drawer.classList.toggle('is-empty', vide);
  }
  function flash(m) { flashMsg = m || ''; clearTimeout(flash.t); if (m) flash.t = setTimeout(function () { flashMsg = ''; D.querySelectorAll('[data-hpn-flash]').forEach(function (f) { f.hidden = true; }); }, 7000); }

  /* ---------- ouverture ---------- */
  var surPagePanier = !!page;
  function ouvrir() {
    if (!drawer || surPagePanier) return;
    lastFocus = lastFocus || D.activeElement;
    var panel = drawer.querySelector('.hpn-panel');
    drawer.classList.add('on'); D.documentElement.classList.add('hpn-lock');
    panel.setAttribute('aria-hidden', 'false');
    setTimeout(function () { var x = drawer.querySelector('[data-hpn-close].hpn-x') || panel; x.focus({ preventScroll: true }); }, 60);
  }
  function fermer() {
    if (!drawer || !drawer.classList.contains('on')) return;
    drawer.classList.remove('on'); D.documentElement.classList.remove('hpn-lock');
    drawer.querySelector('.hpn-panel').setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    lastFocus = null;
  }
  var tPlan = null;
  function planifier(open) {
    if (open) ouvrir();
    clearTimeout(tPlan);
    tPlan = setTimeout(function () { q(function () { return synchro().then(rendre); }); }, 120);
  }

  /* Compatible avec les formulaires de Dawn (product-form.js, quick-add) : ils cherchent <cart-drawer> */
  if (drawer && !customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {
      getSectionsToRender() { return [{ id: 'hover-cart-drawer', selector: '#HvCartBody' }, { id: 'cart-icon-bubble' }]; }
      renderContents() { this.classList.remove('is-empty'); planifier(true); }
      setActiveElement(el) { lastFocus = el; }
      open() { ouvrir(); }
      close() { fermer(); }
    });
  }

  /* Tout ajout au panier fait ailleurs (lots des fiches, scripts des sections…) : on resynchronise et on ouvre */
  var reCart = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  W.fetch = function (input, init) {
    var p = origFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var h = init && init.headers, mine = h && (h['X-HPN'] || (typeof h.get === 'function' && h.get('X-HPN')));
      var meth = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (!mine && meth === 'POST' && reCart.test(url)) {
        var add = /\/cart\/add/.test(url);
        p.then(function (r) { if (r.ok) planifier(add); }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__hvc = (String(m).toUpperCase() === 'POST' && reCart.test(String(u))) ? (/\/cart\/add/.test(String(u)) ? 'add' : 'chg') : null; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () { var x = this; if (x.__hvc) x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) planifier(x.__hvc === 'add'); }); return xs.apply(this, arguments); };

  /* ---------- actions ---------- */
  function majQte(key, n) { return q(function () { return api('cart/change.js', { id: key, quantity: n }).then(synchro).then(rendre); }); }
  function ajouter(items) { return q(function () { return api('cart/add.js', { items: items }).then(synchro).then(rendre); }); }

  D.addEventListener('click', function (e) {
    var t = e.target;
    var ic = t.closest('#cart-icon-bubble, [data-hpn-open]');
    if (ic && drawer && !surPagePanier) { e.preventDefault(); ouvrir(); planifier(false); return; }
    if (!t.closest('[data-hpn-drawer], [data-hpn-page]')) return;
    if (t.closest('[data-hpn-close]')) { e.preventDefault(); fermer(); return; }
    var b = t.closest('[data-hpn-qty]'); if (b && !b.disabled) { e.preventDefault(); var ln = b.closest('[data-hpn-line]'); if (ln) ln.classList.add('is-busy'); majQte(b.getAttribute('data-hpn-qty'), +b.getAttribute('data-q')); return; }
    var a = t.closest('[data-hpn-add]'); if (a) { e.preventDefault(); a.classList.add('is-busy'); ajouter([{ id: +a.getAttribute('data-hpn-add'), quantity: 1 }]); return; }
    // « i » d'un cadeau : l'information s'affiche sous la liste, sans quitter le panier
    var inf = t.closest('[data-qb-info]');
    if (inf) {
      e.preventDefault();
      var bloc = inf.closest('.qb-pick'), pan = bloc && bloc.querySelector('[data-qb-info-panel]'), ouvert = inf.getAttribute('aria-expanded') === 'true';
      if (bloc) Array.prototype.forEach.call(bloc.querySelectorAll('[data-qb-info]'), function (x) { x.setAttribute('aria-expanded', 'false'); });
      if (pan) { pan.hidden = ouvert; if (!ouvert) { pan.innerHTML = inf.getAttribute('data-qb-info'); inf.setAttribute('aria-expanded', 'true'); } }
      return;
    }
    var pk = t.closest('[data-qb-pick]');
    if (pk) {
      e.preventDefault();
      if (pk.getAttribute('aria-pressed') === 'true') return;
      var lst = pk.closest('.qb-pick'); if (lst) lst.classList.add('is-busy');
      choisirCadeau(pk.getAttribute('data-qb-pick'), +pk.getAttribute('data-id'));
      return;
    }
    var go = t.closest('[data-hpn-checkout]');
    if (go) {
      e.preventDefault(); go.classList.add('is-busy');
      chain.then(function () { W.location.href = R + 'checkout'; });
    }
  });
  D.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermer(); });

  /* ---------- démarrage ---------- */
  peindre();
  if (C.enabled) {
    /* panier déjà rempli (retour sur le site, autre onglet) : remet les cadeaux en ordre sans ouvrir */
    var n0 = 0; D.querySelectorAll('[data-hpn-body]').forEach(function (b) { n0 = Math.max(n0, +b.getAttribute('data-count') || 0); });
    if (n0 > 0) q(function () { modifie = false; return synchro().then(function () { if (modifie) return rendre(); annoncer(); }); });
  }
  /* retour arrière (bfcache) : le panier a pu changer ailleurs */
  W.addEventListener('pageshow', function (e) { if (e.persisted) q(function () { return synchro().then(rendre); }); });
  W.HVCart = { open: ouvrir, close: fermer, refresh: function (o) { planifier(!!o); } };
})();
